<template>
    <footer class="footer">
        <v-wrapper>
            <div class="footer__divider">
                <router-link :to="`${path.toLowerCase()}`" class="footer__brand">
                    <img :alt="this.$appSettings.appName" src="/img/logo.svg" />
                </router-link>
                <div class="footer__countries">
                    <router-link
                        :class="country.code === out.code ? 'active' : ''"
                        :key="inx"
                        :to="`/${out.code.toLowerCase()}`"
                        @click.native="$store.commit('modals/modalHandler', { name: 'modalCountry', boolean: false })"
                        v-for="(out, inx) in countries"
                    >
                        <img :alt="out.name" :src="out.flag" />
                        <span>{{ out.name }}</span>
                    </router-link>
                </div>
            </div>
            <div class="footer__divider">
                <div class="footer__menu">
                    <router-link :to="`${path.toLowerCase()}`">Inicio</router-link>
                    <router-link :to="`${path.toLowerCase()}/acerca-de-nosotros`">Nosotros</router-link>
                    <router-link :to="`${path.toLowerCase()}/contacto`">Contacto</router-link>
                    <router-link :to="`${path.toLowerCase()}/terminos-y-condiciones`">Términos y condiciones</router-link>
                    <router-link :to="`${path.toLowerCase()}/politica-de-privacidad`">Política de privacidad</router-link>
                </div>
            </div>
        </v-wrapper>
        <p class="footer__copyright">{{ this.$appSettings.appName}} &copy; {{ new Date().getFullYear() }}</p>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            countries: 'countries/countries',
            country: 'countries/country',
            path: 'path'
        })
    }
}
</script>

<style lang="scss">
.footer {
    padding: 1rem 0;
    background-color: #f3f3f3;

    .wrapper {
        display: flex;
        justify-content: space-between;
    }

    &__divider {
        display: flex;
        align-items: center;
    }

    &__brand {
        margin-right: 2rem;
        img {
            height: 18px;
        }
    }

    &__countries {
        display: grid;
        grid-gap: 0.5rem;
        grid-template-columns: repeat(4, 1fr);
        a {
            user-select: none;
            cursor: pointer;
            padding: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-radius: 4px;
            transition: all 0.4s;
            img {
                height: 20px;
                margin-bottom: 0.2rem;
                object-fit: contain;
            }
            span {
                font-size: 0.8rem;
            }
            &:hover {
                background-color: #f3f3f3;
            }
            &.active {
                background-color: #e3e3e3;
                &:hover {
                    background-color: #e3e3e3;
                }
            }
        }
    }

    &__menu {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        a {
            height: 30px;
            margin-right: 0.5rem;
            margin-left: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.9rem;
        }
    }

    &__copyright {
        padding-top: 1rem;
        padding-bottom: 1rem;
        text-align: center;
    }

    @media (max-width: 992px) {
        .wrapper {
            display: block;
        }

        &__divider {
            flex-wrap: wrap;
        }

        &__brand {
            margin-bottom: 2rem;
            margin-right: auto;
            margin-left: auto;
            img {
                height: 20px;
            }
        }

        &__countries {
            width: 100%;
            margin-bottom: 2rem;
        }
    }
}
</style>
